import React, { Component, Fragment } from 'react'
import ReactDOM from 'react-dom'
import Dialog from './../../Dialog'
import SettingsIconSvg from './SettingsIconSvg'
import injectStyles from 'react-jss'
import RadioButtons from './RadioButtons'
import classNames from 'classnames'

const styles = {
  cancelButton: {
    position: 'absolute',
    bottom: 56,
    left: 0,
    right: 0,
    cursor: 'pointer',
  },
  cancelButtonDisabled: {
    color: 'grey',
  },
  col: {
    width: '50%',
    display: 'inline-block',
    verticalAlign: 'middle',
  },
}

class SettingsIcon extends Component {

  state = {
    showSettingsDialog: false,
  };

  onChangeType = (newType) => {
    this.props.onUpdate({
      type: newType,
    })
  }

  onClose = () => this.setState({ showSettingsDialog: false })

  onOpen = () => this.setState({ showSettingsDialog: true })

  render = () => {
    const { className, type, classes } = this.props
    const { showSettingsDialog } = this.state

    return <Fragment>
      <SettingsIconSvg
        className={className}
        onClick={this.onOpen}
      />
      {showSettingsDialog ? ReactDOM.createPortal(<Dialog>
        <h3>Control Settings</h3>
        <br /><br /><br />
        <div>
          <div className={classes.col}>
            <label>Field Type</label>
          </div>
          <div className={classes.col}>
            <RadioButtons
              value={type}
              values={[
                'list',
                'radio',
                'text',
                'date',
                'checkbox',
              ]}
              onChange={this.onChangeType}
            />
          </div>
        </div>
        <div
          className={classNames({
            [classes.cancelButton]: true,
            //[classes.cancelButtonDisabled]: saving,
          })}
          onClick={this.onClose}
        >Close</div>
      </Dialog>, document.body): null}
    </Fragment>
  }
}

export default injectStyles(styles)(SettingsIcon)


// WEBPACK FOOTER //
// ./src/modules/ControlWrapper/SettingsIcon/SettingsIcon.js